// ©2024 Austin App House. All rights reserved.
import React from 'react';
import { withRouter } from 'react-router-dom';
import workOrderStatusControl from '../../../utils/workOrderStatusControl';

const ControlsButton = ({
  workOrder,
  setCurrentWorkOrder,
  fetchApplicantsForWorkOrder,
  toggleModal,
  history,
  match,
}) => {
  const workOrderControlByStatus = workOrder ? workOrderStatusControl(workOrder.status) : {};

  return (
    <>
      <button
        type="button"
        className="wo-btn wo-btn--details"
        onClick={() => {
          setCurrentWorkOrder(workOrder);
          toggleModal(true, 'viewDetailsWorkOrderModal', true, { id: workOrder._id });
          const { tab } = match.params;
          const pathname = tab ? `/dashboard/${tab}` : '/dashboard';
          history.replace({
            pathname,
            search: `?type=work-order&id=${workOrder._id}`,
          });
        }}
      >
        Details
      </button>
      {workOrderControlByStatus.beforeAssigned && !workOrderControlByStatus.canceled && (
        <>
          {(!workOrderControlByStatus.draft || workOrder.routedStatus) && (
            <button
              type="button"
              className="wo-btn wo-btn--details"
              onClick={() => {
                fetchApplicantsForWorkOrder(workOrder._id);
                setCurrentWorkOrder(workOrder);
                toggleModal(true, 'viewAllApplicantsForWorkOrderModal');
              }}
            >
              View Applicants
            </button>
          )}
          <button
            type="button"
            className="wo-btn wo-btn--details"
            onClick={() => {
              setCurrentWorkOrder(workOrder);
              fetchApplicantsForWorkOrder(workOrder._id);
              toggleModal(true, 'nearByContractorModal');
            }}
          >
            Contractors Near-by
          </button>
        </>
      )}
    </>
  );
};

export default withRouter(ControlsButton);
